const locale = {
    message: {
        services: "Services",
        welcome: "Welcome",
        email: "Email",
        password: "Password",
        login: "Login",
        logout: "Logout",
        check_credencials: "Check your credentials",
        list_reservations: "Services list",
        list_completed_reservations: "Completed service list",
        contact: "Contact",
        evidence: "Evidences",
        comment: "Comment",
        type_a_comment: "Type a comment",
        evidence_images: "Evidence images",
        take_a_photo: "Take photos",
        confirm: "Confirm",
        cancel: "Cancel",
        close: "Close",
        service_shuttle: "Shuttle service",
        contact_us: "Contact us",
        chat: "Chat",
        phone: "Phone",
        loading_more_information: "Loading more information...",
        completed_reservations: "Completed reservations",
        home: "Home",
        service_sheet: "Service sheet",
        welcome_sign: "Show welcome sign",
        loading: "Loading...",
        name: "Name",
        business_phone: "Business phone",
        personal_phone: "Personal phone",
        model: "Model",
        manufacturer: "Manufacturer",
        car_registration: "Car registration",
        vehicle_updated: "The assigned vehicle has changed",
        driver_updated: "The assigned driver has changed",
        error_update_reservation: "There was an error while updating the reservation",
        change_driver: "Change driver",
        change_vehicle: "Change vehicle",
        driver_information: "Driver information",
        vehicle_information: "Vehicle information",
        precise_location_permission_title: "Precise location permission",
        precise_location_permission_description: "We need to collect your precise location to track the transfer service even when the app is in the background",
        vehicle: "vehicle",
        save: "Save",
        id: "Reservation number",
        tracing_number: "Tracing number",
        today_reservations: "Today",
        next_days: "Next days"
    },
    status: {
        "none": "Sin asignar",
        "waiting-on-meeting-point": "Waiting on meeting point",
        "on-way-to-meeting-point": "On way to meeting point",
        "customer-on-board": "Customer on board",
        "no-show": "Client didn't show",
        "completed": "Trip completed",
        "cancelled": "Cancelled",
    },
    reservation: {
        service_shuttle: "Shuttle service",
        service_by_hour: "Service per hour",
        service_tour: "Tour service",
        reservation: "Reservation",
        status: "Status",
        time_service: "Service time",
        time_pickup: "Pickup time",
        passangers: "Passengers",
        id: "ID",
        flight_number: "Flight number",
        address_origin: "Origin address",
        address_destination: "Destination address",
        notes: "Special notes",
        addons: "Extras",
        change_status: "Change status to",
    },
    app_settings: {
        update_available: "Update available",
        update_last_version: "There's an update available, please update to the last version.",
        update: "Update",
        cancel: "Cancel"
    }
}

export default locale;